// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Route$PdgLookup = require("./Route.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.bs.js");

function useRouter() {
  return Route$PdgLookup.fromUrl(RescriptReactRouter.useUrl(undefined, undefined));
}

function push(route) {
  RescriptReactRouter.push(route);
}

function Router$Link(props) {
  var route = props.route;
  return JsxRuntime.jsx("a", {
              children: props.children,
              href: route,
              onClick: (function ($$event) {
                  if (!$$event.defaultPrevented && $$event.button === 0 && !$$event.altKey && !$$event.ctrlKey && !$$event.metaKey && !$$event.shiftKey) {
                    $$event.preventDefault();
                    return RescriptReactRouter.push(route);
                  }
                  
                })
            });
}

var Link = {
  make: Router$Link
};

exports.useRouter = useRouter;
exports.push = push;
exports.Link = Link;
/* react/jsx-runtime Not a pure module */
